import { useMemo } from 'react';

import { useBackerHasStudentFeesAccess } from '@givebacks/api/backer';

import { useInternalToolsMenu } from '../../internalTools/useInternalToolsMenu';
import { UserFeatureFlags } from '../flags.types';

type AccessFeatures = UserFeatureFlags;

const useUserReleaseControl = ({ feature }: { feature: AccessFeatures }) => {
  const {
    hasStudentFeesAccess,
    isLoading: isStudentFeesActivelyLoading,
    isInitialLoading: isStudentFeesInitialLoading,
  } = useBackerHasStudentFeesAccess();
  const { getToolValue, isToolsLoading } = useInternalToolsMenu();

  const isStudentFeesLoading = useMemo(() => {
    return isStudentFeesActivelyLoading || isStudentFeesInitialLoading;
  }, [isStudentFeesActivelyLoading, isStudentFeesInitialLoading]);

  const status = useMemo(() => {
    // If we are in a non-production environment and the feature flag override is enabled, return true
    if (import.meta.env.VITE_API_ENV !== 'production' && getToolValue('feature-flag-override')) {
      return true;
    }

    switch (feature) {
      case 'user.studentFees':
        return hasStudentFeesAccess;
      default:
        return false;
    }
  }, [feature, getToolValue, hasStudentFeesAccess]);

  const isLoading = useMemo(() => isStudentFeesLoading || isToolsLoading, [
    isToolsLoading,
    isStudentFeesLoading,
  ]);

  return { accessStatus: status, isLoading };
};

export { useUserReleaseControl };
